import axios from 'axios'

const FILE_BASE_URL = String(process.env.VUE_APP_FILE_BASE_URL || '').replace(/\/+$/, '')
const LOCAL_FILE_BASE_URL = `${String(process.env.BASE_URL || '/').replace(/\/+$/, '')}/file`
const staticDataClient = axios.create({ timeout: 10000 })

function fileUrl(baseUrl, fileName) {
  return `${baseUrl}/${fileName}?_=${Date.now()}`
}

async function requestJson(baseUrl, fileName) {
  const response = await staticDataClient.get(fileUrl(baseUrl, fileName), {
    headers: { Accept: 'application/json' },
    transformResponse: axios.defaults.transformResponse
  })
  return response.data
}

function validateArray(data, fileName, validator) {
  if (!Array.isArray(data) || !data.length || (validator && !data.every(validator))) {
    throw new Error(`${fileName} 数据格式不正确`)
  }
  return data
}

export async function loadStaticJson(fileName, validator) {
  if (FILE_BASE_URL) {
    try {
      return validateArray(await requestJson(FILE_BASE_URL, fileName), fileName, validator)
    } catch (error) {
      // The bundled copy keeps the page usable when the managed file is unavailable.
    }
  }
  return validateArray(await requestJson(LOCAL_FILE_BASE_URL, fileName), fileName, validator)
}

const isTemplate = item => item && item.id !== undefined && item.name && item.content && item.category !== undefined
const isCategory = item => item && item.value !== undefined && item.label
const isMaterial = item => item && item.mateId && item.name && item.url
const isTask = item => item && item.id !== undefined && item.name && item.status

export async function getEditorStaticData() {
  const [templates, categories, voices, music, titleStyles, subtitleStyles] = await Promise.all([
    loadStaticJson('editor-templates.json', isTemplate),
    loadStaticJson('template-categories.json', isCategory),
    loadStaticJson('editor-voices.json', isMaterial),
    loadStaticJson('editor-background-music.json', isMaterial),
    loadStaticJson('editor-title-styles.json', isMaterial),
    loadStaticJson('editor-subtitle-styles.json', isMaterial)
  ])
  return { templates, categories, voices, music, titleStyles, subtitleStyles }
}

export function getStaticContentTasks() {
  return loadStaticJson('content-tasks.json', isTask)
}
